import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsAndConditions.css';
import {
  BackButton,
  EnterpriseCard,
  EnterpriseGrid,
  EnterpriseHero,
  EnterpriseShell,
  EnterpriseTopBar
} from './ui/EnterpriseLayout';

function TermsAndConditions() {
  const navigate = useNavigate();

  return (
    <EnterpriseShell>
      <EnterpriseTopBar
        right={
          <>
            <BackButton onClick={() => navigate('/')} />
            <span className="vt-chip vt-chip--subtle">Terms</span>
          </>
        }
      />

      <EnterpriseHero
        title="Veritage Age Verification Terms & Conditions"
        subtitle="Last updated: 19th January, 2026"
      />

      <EnterpriseGrid columns={1}>
        <EnterpriseCard>
          <div className="terms-content">
            <h2>1. Overview</h2>
            <p>
              <strong>1.1</strong> These Terms & Conditions ("Terms") govern your use of the Veritage Age Verification service ("Age Verification"), provided by Veritage Ltd, a company incorporated and registered in Ireland with its registered office at Spaces Donnybrook House, Donnybrook House, 36-42 Donnybrook Road, Dublin 4, D04 WN59, Ireland.
            </p>
            <p>
              <strong>1.2</strong> By accessing or using Age Verification — whether directly on a hosted page, via iframe integration, API, or any embedded Veritage age check tool — you agree to be bound by these Terms. If you do not agree, you must not use the Age Verification service.
            </p>

            <h2>2. Changes to Terms</h2>
            <p>
              <strong>2.1</strong> Veritage may update or amend these Terms at any time to reflect changes in our services or legal obligations. Any changes will be effective when posted. Before using the Age Verification service you should review the current Terms.
            </p>

            <h2>3. Availability and Suspension</h2>
            <p>
              <strong>3.1</strong> Age Verification may be updated, suspended, or withdrawn by Veritage at any time for technical, legal, business, or operational reasons. We will try to provide reasonable notice where possible, but are not obligated to do so.
            </p>
            <p>
              <strong>3.2</strong> Veritage does not guarantee uninterrupted access to the service and is not liable for temporary unavailability.
            </p>

            <h2>4. Acceptable Use</h2>
            <p>
              <strong>4.1</strong> You agree to use Age Verification only for lawful purposes. In particular, you must not use it:
            </p>
            <ul>
              <li>to violate applicable Irish, EU, or other local laws;</li>
              <li>fraudulently or in a way that harms minors;</li>
              <li>to attempt to bypass, trick, manipulate, disable, or reverse‑engineer the Age Verification system;</li>
              <li>to upload or transmit malware, viruses, or harmful code.</li>
            </ul>
            <p>
              <strong>4.2</strong> You may not use Veritage's intellectual property — including software, interfaces, APIs, or content — outside what is expressly permitted by Veritage or under licence.
            </p>

            <h2>5. Intellectual Property</h2>
            <p>
              <strong>5.1</strong> All rights, title, and interest in the Age Verification service, including underlying software, trademarks, and documentation, belong to Veritage or its licensors.
            </p>
            <p>
              <strong>5.2</strong> Nothing in these Terms transfers any intellectual property rights to you.
            </p>

            <h2>6. Liability and Disclaimers</h2>
            <p>
              <strong>6.1</strong> Age Verification estimates or confirms age based on configured methods chosen by the integrating client. Veritage provides no guarantee that a particular user will be validated or that estimates are error‑free.
            </p>
            <p>
              <strong>6.2</strong> To the fullest extent permitted by law, Veritage's total liability under or in connection with these Terms is limited to direct losses only and does not include indirect, consequential, commercial, or special damages.
            </p>
            <p>
              <strong>6.3</strong> Nothing in these Terms excludes liability for death or personal injury caused by our negligence or for any other liability that cannot be excluded under Irish or EU law.
            </p>

            <h2>7. Third‑Party Links and Content</h2>
            <p>
              <strong>7.1</strong> If Age Verification links to third‑party websites or services, Veritage is not responsible for their content, availability, or policies. Links are provided for convenience only.
            </p>

            <h2>8. Governing Law and Jurisdiction</h2>
            <p>
              <strong>8.1</strong> These Terms and any dispute arising out of or in connection with them are governed by Irish law.
            </p>
            <p>
              <strong>8.2</strong> You agree that the courts of Ireland will have exclusive jurisdiction to settle any dispute or claim arising from these Terms.
            </p>

            <h2>9. Contact Details</h2>
            <p>
              If you have questions about these Terms or need to contact Veritage regarding Age Verification, please contact:
            </p>
            <p>
              <strong>Veritage Ltd</strong><br />
              Address: Spaces, Donnybrook House, 36-42 Donnybrook Road, Dublin 4, D04 WN59, Ireland<br />
              Email: <a href="mailto:terms@veritage.io">terms@veritage.io</a>
            </p>
          </div>
        </EnterpriseCard>
      </EnterpriseGrid>
    </EnterpriseShell>
  );
}

export default TermsAndConditions;
